export const tags = ['Policy', 'Guide', 'Manual'];

export const imageTypes = ['welcome', 'onboarding', 'training'];

export const taskTypes = ['Document', 'Video', 'Question', 'Signature'];
